<template>
  <div class="input-component-base">
    <entry-form-header
      class="row"
      :disable-steps="true"
      :disable-prices="true"
      :items-id="itemsId"
    />
    <entry-form
      enctype="multipart/form-data"
      method="post"
      :force-member-form="true"
      :submit-face="submitFace"
      :items-id="itemsId"
      :input-param="inputParam"
      :action="action"
      @on-before-submit="onBeforeSubmit"
    />
  </div>
</template>

<script>
export default {
  name: 'DeluxeLpA',
  props: {
    postParams: {
      type: [Object, Array],
      default: () => ({})
    },
    // formdata関連
    action: String,
    method: {
      type: String,
      default: 'post'
    },
    itemsId: [Number, String],
    itemScheduleId: [Number, String],
    inputParam: Object,
    categoryId: [Number, String],
    guestId: String,

    // ログインフォームに渡す値
    reissueKey: String,
    returnPath: {
      type: String,
      default: window.location.href
    },
    entryDetailRequired: Boolean,
    isRandSelect: Boolean,
    orderGenre: String,
    expText: String,
    returnParams: {
      type: [Object, Array],
      default: () => ({})
    },
    inputEntryType: [Number, String],
    movieCustomPlanningId: [Number, String]
  },
  data(){
    return {
      submitFace: `<span class="button-face">無料で占う</span>`,
    }
  },
  methods: {
    onBeforeSubmit() {
      // console.log('event:on Before Submit')
    }
  },
}
</script>

<style scoped lang="scss">
@import "../../../../../sass/commons/commonVariables.scss";
.lp-component-base {

}

/deep/ .entryFormFooter button,
.button-link {
  min-width: 270px;
  max-width: 400px;
  margin: 0 auto;
  font-weight: bold;
  font-size: 16px;
  color: white;
  min-height: 55px;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  border-radius: 100px;
  cursor: pointer;
  position:relative;
  z-index:1;
  background: $col_def_gradient;
  box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.15);
  user-select: none;
  &::before {
    position:absolute;
    top:0;
    left:0;
    z-index:-1;
    box-sizing:border-box;
    border-radius:100px;
    padding:1px;
    width:100%;
    height:100%;
    background:#fff;
    background-clip:content-box;
    content:"";
  }
  .button-face {
    color: $col_temp_key1;
    background: $col_def_gradient;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    /deep/ {
      .notice,
      .face-body{
        display: block;
        width: 100%;
        color: $col_temp_key1;
        //グラデ方向崩れるため個別指定
        background: $col_def_gradient;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .notice {
        font-size: 0.8em;
        line-height: 1;
      }
    }
  }

  &[disabled]{
    pointer-events: none;
    background: #DCDFE2;
    .button-face {
      color: #DCDFE2;
      background: none;
      -webkit-text-fill-color: initial;
      -webkit-background-clip: border-box;
    }
  }


  &.disable {
    pointer-events: none;
    background: #DCDFE2;
    .button-face {
      color: #DCDFE2;
      background: none;
      -webkit-text-fill-color: initial;
      -webkit-background-clip: border-box;
    }
  }
}


</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/deluxe/components/DeluxeInputA.vue